import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { StoreService } from '../../store/store.service';

export const personDetailResolver: ResolveFn<void> = async (
  route: ActivatedRouteSnapshot,
) => {
  const store = inject(StoreService);

  const {
    persons: { setActivePerson },
  } = store.getActions();

  await setActivePerson(+route.paramMap.get('id')!);
  return;
};
